import { allCommandNames, allowedRemoteCommandNames } from 'logic/deviceScriptParser';
import { useCallback, MouseEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type Props = {
    remoteUpdatesDisabled: boolean;
    onClickAdd(id: string): void;
};

export const AddCommandLine = ({ onClickAdd, remoteUpdatesDisabled }: Props) => {
    const { t } = useTranslation();

    const handleClick = useCallback((e: MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        onClickAdd(e.currentTarget.dataset.cmd!);
        return false;
    }, [ onClickAdd ]);

    function renderItem(commandName: string) {
        return (
            <div
                className="item"
                key={ commandName }
                data-cmd={ commandName }
                onClick={ handleClick }
            >
                { commandName }
            </div>
        );
    }

    const menuItems = useMemo(() => {
        return (remoteUpdatesDisabled ? allowedRemoteCommandNames : allCommandNames).map(renderItem);
    }, [ handleClick ]);

    return (
        <div className="add-command-line">
            <div className="ui compact menu">
                <div className="ui simple dropdown item">
                    { t('DEVICE.COMMANDS.ADD_COMMAND') }
                    <i className="dropdown icon"/>
                    <div className="menu">
                        { menuItems }
                    </div>
                </div>
            </div>
        </div>
    );
};
